import React from "react";
import { Container } from "react-bootstrap";

const Certifications = ({ items, className }) => {
    const certs =
        items?.filter(({ title, description }) => title || description) || [];

    if (certs.length === 0) return null;

    return (
        <section className={`certifications ${className || ""}`}>
            <Container>
                <ul className="certifications__grid">
                    {certs.map(({ title, description }, index) => (
                        <li className="certifications__item" key={index}>
                            {title && (
                                <h3 className="certifications__title">
                                    {title}
                                </h3>
                            )}
                            {description && (
                                <p className="certifications__text">
                                    {description}
                                </p>
                            )}
                        </li>
                    ))}
                </ul>
            </Container>
        </section>
    );
};

export default Certifications;
